import React, { useState } from 'react';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const BrandLogo = () => <div className="relative w-10 h-10" data-id="element-114">
    <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full" data-id="element-115"></div>
    <div className="absolute inset-2 bg-white rounded-full" data-id="element-116"></div>
    <div className="absolute inset-3 bg-gradient-to-br from-green-400 to-green-600 rounded-full" data-id="element-117"></div>
  </div>;
export const Header = () => {
  const {
    t
  } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };
  return <header className="w-full bg-white shadow-md fixed top-0 left-0 right-0 z-50" data-id="element-118">
      <div className="container mx-auto px-4 md:px-8" data-id="element-119">
        <div className="flex items-center justify-between py-4" data-id="element-120">
          <div className="flex items-center space-x-3" data-id="element-121">
            <BrandLogo data-id="element-122" />
            <h1 className="text-2xl font-bold text-navy-900" data-id="element-123">BRANROCK</h1>
          </div>
          <nav className="hidden md:flex items-center space-x-8" data-id="element-124">
            <button onClick={() => scrollToSection('beneficios')} className="text-gray-700 hover:text-blue-600 font-medium transition" data-id="element-125">
              {t('header.benefits')}
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="text-gray-700 hover:text-blue-600 font-medium transition" data-id="element-126">
              {t('header.testimonials')}
            </button>
            <button onClick={() => scrollToSection('precios')} className="text-gray-700 hover:text-blue-600 font-medium transition" data-id="element-127">
              {t('header.pricing')}
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-blue-600 font-medium transition" data-id="element-128">
              {t('header.faq')}
            </button>
            <a href="https://knovastore.com/cart/47931982774491:1" className="flex items-center bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded-lg transition" data-id="element-129">
              <ShoppingCart className="mr-2" size={18} data-id="element-130" />
              {t('header.buyNow')}
            </a>
          </nav>
          <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-131">
            {isMenuOpen ? <X size={28} data-id="element-132" /> : <Menu size={28} data-id="element-133" />}
          </button>
        </div>
        {isMenuOpen && <div className="md:hidden py-4 border-t" data-id="element-134">
            <nav className="flex flex-col space-y-4" data-id="element-135">
              <button onClick={() => scrollToSection('beneficios')} className="text-gray-700 hover:text-blue-600 font-medium text-left" data-id="element-136">
                {t('header.benefits')}
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="text-gray-700 hover:text-blue-600 font-medium text-left" data-id="element-137">
                {t('header.testimonials')}
              </button>
              <button onClick={() => scrollToSection('precios')} className="text-gray-700 hover:text-blue-600 font-medium text-left" data-id="element-138">
                {t('header.pricing')}
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-blue-600 font-medium text-left" data-id="element-139">
                {t('header.faq')}
              </button>
              <a href="https://knovastore.com/cart/47931982774491:1" className="flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-6 rounded-lg transition" data-id="element-140">
                <ShoppingCart className="mr-2" size={18} data-id="element-141" />
                {t('header.buyNow')}
              </a>
            </nav>
          </div>}
      </div>
    </header>;
};